import React from 'react';
import { Label, Icon } from "semantic-ui-react";



export default ({ filter, filters, onFilterDelete, onBooleanFilterChange }) => {

  function renderLabels() {
    if (Array.isArray(filters[filter])) {
      return (
        filters[filter].map((f, i) => (
          <Label key={i} style={{ 'marginBottom': '3px' }}>
            {f}
            <Icon
              onClick={onFilterDelete.bind(this, f, filter)}
              name='delete'
            />
          </Label>
        ))
      )
    }
    else {
      return (
        filters[filter] ?
          <Label style={{ 'marginBottom': '3px' }}>
            {filters[filter]}
            <Icon
              onClick={onBooleanFilterChange.bind(this, filter, {})}
              name='delete'
            />
          </Label> : null
      )
    }
  }

  return <div>
    {filters && renderLabels()}
  </div>
}



// WEBPACK FOOTER //
// ./src/component/SelectedFiltersLabels.js